export default __webpack_public_path__ + "d70510f1e041e7eb130471552897beff.svg";